import React from 'react';
import PropTypes from "prop-types";
import AbstractTab from "./AbstractTab";
import {connect} from "react-redux";
import {addDetailWindow, setDetailWindow} from "../../actions/details";
import FeatureUtils from "../../utils/FeatureUtils";
import axios from "axios";
import Spinner from "qwc2/components/widgets/Spinner";
import LocaleUtils from "qwc2/utils/LocaleUtils";

class PropertiesTab extends AbstractTab {

    static propTypes = {
        addDetailWindow: PropTypes.func,
        feature: PropTypes.object,
        setDetailWindow: PropTypes.func,
        tab: PropTypes.object,
        windowId: PropTypes.string,
        windowType: PropTypes.string
    }

    static defaultProps = {
        feature: {},
        tab: {},
        windowId: ''
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true
        };
    }

    componentDidMount() {
        if (typeof (this.props.tab.url) !== 'undefined') {
            const url = FeatureUtils.prepareUrl(this.props.feature, this.props.tab.url);
            const self = this;
            axios(url).then(response => {
                self.setState({
                    data: response.data,
                    isLoading: false
                });
            }).catch(error => {
                console.log("Error *** : " + error);
            });
        }
    }

    getKeyValues(result) {
        const dataList = [];
        if (result === null || typeof (result) === 'undefined') {
            return dataList;
        }

        if (result.properties) {
            if (this.props.tab.config && this.props.tab.config.properties) {
                this.props.tab.config.properties.forEach(p => {
                    const attrib = p.key;
                    let value = null;
                    let plainValue = null;
                    if (p.value) {
                        value = p.value;
                        value = FeatureUtils.genericResolve(result, value);
                        plainValue = value;
                        if (this.hideProperty(value, p.hide)) {
                            return;
                        }
                    } else {
                        if (typeof (result.properties[attrib]) === 'undefined') {
                            return;
                        }
                        if (this.hideProperty(result.properties[attrib], p.hide)) {
                            return;
                        }
                        plainValue = result.properties[attrib];
                        value = this.attribValue(plainValue, p);
                    }
                    if (p.type) {
                        switch(p.type.toLowerCase()) {
                            case 'linkphone':
                                value = this.linkPhone(value);
                                break;
                            case 'linkemail':
                                // need to use plain value because it might already be formatted
                                value = this.linkEmail(plainValue);
                                break;
                            case 'linkdetails':
                                if (p.href) {
                                    const href = FeatureUtils.genericResolve(result, p.href);
                                    value = (
                                        <span className="feature-link" onClick={() => this.goToObjectUrl(href)}>
                                            {value}
                                        </span>
                                    );
                                } else {
                                    value = this.linkDetails(result, attrib, value);
                                }
                                break;
                            case 'linktitle':
                                value = this.renderLinkTitle(result, p.objectType);
                                break;
                        }
                    }
                    dataList.push({
                        label: p.label,
                        value: value
                    });
                });

            } else {
                Object.keys(result.properties).forEach(attrib => {
                    if (result.properties[attrib] === null) {
                        return;
                    }
                    if (typeof (result.properties[attrib]) === 'object') {
                        return;
                    }
                    if (typeof (result.properties[attrib]) === 'undefined') {
                        return;
                    }
                    dataList.push({
                        label: attrib,
                        value: this.attribValue(result.properties[attrib])
                    });
                });
            }
        } else {
            console.log('Result', result);
        }
        return dataList;
    }

    getItem = () => {
        if (typeof (this.props.tab.url) !== 'undefined') {
            return this.state.data.features[0];
        } else {
            return this.props.feature;
        }
    }

    renderProperties = () => {
        return this.getKeyValues(this.getItem()).map((kv, index) => {
            return (
                <tr key={index}>
                    <td className="identify-attr-title"><i>{kv.label}</i></td>
                    <td className="identify-attr-value">{kv.value}</td>
                </tr>
            );
        });
    };

    render() {
        if (typeof (this.props.tab.url) !== 'undefined') {
            return (
                <div>
                    {this.state.isLoading &&
                        <div>
                            <Spinner/>
                            <div>{LocaleUtils.tr("attribtable.loading")}</div>
                        </div>
                    }
                    {!this.state.isLoading &&
                        <table className="attribute-list">
                            <tbody>
                                {this.renderProperties()}
                            </tbody>
                        </table>
                    }
                </div>
            );
        }
        return (
            <div>
                <table className="attribute-list">
                    <tbody>
                        {this.renderProperties()}
                    </tbody>
                </table>
            </div>
        );
    }

    linkDetails(result, attrib, value) {
        if (result.links) {
            for (let i = 0; i < result.links.length; i++) {
                const link = result.links[i];
                if (link.href.indexOf(value) > -1) {
                    return (
                        <span className="feature-link" onClick={() => this.goToObjectUrl(link.href)}>
                            {link.title}
                        </span>
                    );
                }
            }
        }
        return (
            <span className="feature-link" onClick={() => this.goToObject(result.properties[attrib], p.objecttype)}>
                {value}
            </span>
        );
    }
}

const selector = () => ({});

export default connect(selector, {
    setDetailWindow: setDetailWindow,
    addDetailWindow: addDetailWindow,
})(PropertiesTab);
